import { createSlice } from "@reduxjs/toolkit";

import { getClosuresReportData, addClosuresReportData } from "../thunks/closuresReportThunks";

interface ClosureReportListState {
  addClosureReport: any[];
  closureReportSuccess: any;
  loading: boolean;
  error: string | null;
}

const initialState: ClosureReportListState = {
  addClosureReport: [],
  closureReportSuccess: null,
  loading: false,
  error: null,
};

export const closureReportSlice = createSlice({
  name: "closureReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Handling getClosuresReportData
    builder
      .addCase(getClosuresReportData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getClosuresReportData.fulfilled, (state, action) => {
        state.closureReportSuccess = action.payload;
        state.loading = false;
      })
      .addCase(getClosuresReportData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });

    // Handling addClosuresReportData
    builder
      .addCase(addClosuresReportData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addClosuresReportData.fulfilled, (state, action) => {
        // state.addClosureReport = action.payload || [];
        state.loading = false;
      })
      .addCase(addClosuresReportData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export default closureReportSlice.reducer;